//
export default [
    {
        text: "#",
        value: "id",
    },
    {
        text: "responsable",
        value: "g_user_name",
    },
    {
        text: "producto",
        value: "wh_product_name",
    },
    {
        text: "bodega origen",
        value: "wh_warehouse_from_name",
    },
    {
        text: "bodega destino",
        value: "wh_warehouse_to_name",
    },
    {
        text: "n° items",
        value: "wh_detail_repacking_historics_length",
        align: "center",
        format: "number",
    },
    {
        text: "fecha de creación",
        value: "created_at",
        format: "datetime",
    },
]